<!--  -->
<template>
    <div>
        <div class="banner">



            <div class="banner-center">
                <div class="textbox">
                    <div class="banner-text1">标准接口开发指南</div>
                    <div class="banner-text2">助力建设全国统一大市场，优化市场营商环境</div>
                </div>

                <div>
                    <img src="../assets/img/banner2/12-2.png" alt="" class="banner-img">
                </div>
            </div>




        </div>



        <div>
              <!-- 接入指南 -->
      <section>
        <mytitle title="接入指南"></mytitle>
        <main class="list-main">
          <template v-for="(item, index) in guides" :key="index">
            <StandardCard :title="item.title" @preview="previewGuide(item)" @download="downloadGuide(item)" />
          </template>
        </main>
      </section>
        </div>












    </div>


</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, onMounted } from 'vue'



import mytitle from '../components/title.vue'
import StandardCard from '../components/standard/standard-card'
import { ElMessage } from 'element-plus'

import { getRemoteBidEvaluationDocument,newEndpointDownload } from '../utils/axios/index.js'

// 接入指南
const guides = ref([
  { title: '远程异地评标技术标准<br>远程异地评标项目登记工具接入指南', type: 8, name: '远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南' },

  { title: '远程异地评标技术标准<br>场所工位预约工具接入指南', type: 9, name: '远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南' },

  { title: '远程异地评标技术标准<br>场地专家签到工作台接入指南', type: 10, name: '远程异地评标和评标专家库共享技术标准_场地专家签到工作台接入指南' },


  { title: '远程异地评标技术标准<br>场地专家评标登录接入指南', type: 11, name: '远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南' },

  { title: '远程异地评标技术标准<br>专家库共享抽取工具接入指南', type: 12, name: '远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南' },





])



// 预览 
const previewGuide = (item: any) => {
  // getRemoteBidEvaluationDocument({ documentType:item.type }).then(res => {
  //       window.open(res.data.documentUrl, '_blank');

  //   }).catch(res => {
  //       ElMessage.warning('功能开发中，敬请期待！')
  //   })
  if (item.type == '8') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '远程异地评标项目登记工具接入指南预览'])
    }
    if (item.type == '9') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '场所工位预约工具接入指南预览'])
    }
    if (item.type == '10') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '场地专家签到工作台接入指南预览'])
    }
    if (item.type == '11') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '场地专家评标登录工作台接入指南预览'])
    }
    if (item.type == '12') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '专家库共享抽取工具接入指南预览'])
    }
  window.open(item.name + '.pdf', '_blank');

}


// 下载 
const downloadGuide = (item: any) => {
    // let name2 = ''
    // getRemoteBidEvaluationDocument({ documentType: item.type }).then(res => {
    //     name2 = res.data.documentName
    //     let url = res.data.name
    //     newEndpointDownload({contentDisposition:'attachment',filePath:url}).then(res => {
    //         var blob = new Blob([res])
    //         let fname = name2 + '.pdf'; //下载文件的名字
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //             window.navigator.msSaveOrOpenBlob(blob, fname);
    //         } else {
    //             let objectUrl = URL.createObjectURL(blob);
    //             let link = document.createElement("a");
    //             link.href = objectUrl;
    //             link.setAttribute("download", fname);
    //             document.body.appendChild(link);
    //             link.click();
    //         }
    //     })


      
    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })


    const a = document.createElement('a')
    a.href = item.name + '.pdf'
    a.download = item.name + '.pdf'
    a.click()



    if (item.type == '8') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '远程异地评标项目登记工具接入指南下载'])
    }
    if (item.type == '9') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '场所工位预约工具接入指南下载'])
    }
    if (item.type == '10') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '场地专家签到工作台接入指南下载'])
    }
    if (item.type == '11') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '场地专家评标登录工作台接入指南下载'])
    }
    if (item.type == '12') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '专家库共享抽取工具接入指南下载'])
    }
  



}


</script>
<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 577px;
    position: relative;
    background: url('../assets/img/banner2/12-1.png') no-repeat center center;
    background-size: cover;
    overflow: hidden;

    .banner-center {
        width: 1200px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
        top: 116px;

    }


    .textbox {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .banner-img {
        height: 387px;
        margin-top: 42px;
        margin-right: -124px;
    }

    .banner-text1 {
        color: var(--Color-Neutral-neutral-11, #323335);
        
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 70px;
        text-align: left
    }

    .banner-text2 {
        color: var(--Color-Neutral-neutral-10, #64666B);
        text-align: center;
        
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-align: left
    }


}
section {
  padding: 64px 0;
  background-color: #ffffff;

  li {
    list-style: none;
  }

  &.gray {
    background-color: #f8f8f9;
  }

  &>main {
    width: 1200px;
    margin: 72px auto 0;
  }

  .use-case {
    position: relative;
    height: 396px;
    background: url("../assets/img/standard/use-case-bg.png") no-repeat top center/793.5px 590.85px;
    margin: 45px auto -64px;

    li {
      position: absolute;
      display: flex;
      align-items: center;
      width: 325px;
      height: 86px;
      border-radius: 12px;
      border: 3px solid #F4F4F5;
      box-shadow: 11.48px 11.48px 28.69px 0px rgba(55, 99, 170, 0.1);
      background-color: #FFFFFF;
      font-size: 22px;
      color: #323335;
      font-weight: 500;

      img {
        // width: 86px;
        // height: 86px;
        width: 52px;
        height: 52px;
        margin-right: 6px;
        margin-left: 25px;
      }

      &:nth-child(1) {
        top: 34px;
        left: 138px;
      }

      &:nth-child(2) {
        top: 34px;
        right: 138px;
      }

      &:nth-child(3) {
        top: 170px;
        left: 78px;
      }

      &:nth-child(4) {
        top: 170px;
        right: 78px;
      }
    }
  }

  .share-ideas {
    display: flex;
    justify-content: space-between;
    background: url('../assets/img/standard/china-map.png') no-repeat bottom -28px left 327px/519px 398px;

    .share-card {
      width: 360px;
      border-radius: 8px;
      overflow: hidden;

      h3 {
        font-size: 20px;
        font-weight: 600;
        line-height: 64px;
        text-align: center;
        background-color: #3461FF;
        color: #ffffff;
      }

      .card-main {
        box-sizing: border-box;
        padding-bottom: 16px;
        border: 1px solid #F4F4F5;
        border-top: 0;
      }

      .idea-item {
        padding: 24px 22px 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #666666;

        b {
          font-weight: 600;
        }



        .idea-title {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 500;
          color: #323335;

          img {
            width: 48px;
            height: 48px;
            margin-right: 16px;
          }
        }
      }
    }
  }

  .list-main {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -24px;

    &>div {
      margin-right: 16px;
      margin-bottom: 24px;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .principle-main {
    position: relative;

    ul {
      display: flex;
    }

    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 2px solid #FFFFFF;
      background: url('~@/assets/img/standard/arrow-left.png') no-repeat center/7.78px 12.73px, #F3F5F8;
      box-sizing: border-box;
      cursor: pointer;
      box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.8), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);

      &-left {
        left: -50px;
      }

      &-right {
        right: -50px;
        background: url('~@/assets/img/standard/arrow-right.png') no-repeat center center/7.78px 12.73px, #F3F5F8;
      }
    }

    .principle-item {
      flex-shrink: 0;
      width: 388px;
      height: 238px;
      margin-right: 16px;
      border-radius: 8px;
      border: 2px solid #F4F4F5;
      background: url('~@/assets/img/standard/carousel-1.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
      padding: 47px 24px 0;
      box-sizing: border-box;

      &:nth-child(2) {
        background: url('~@/assets/img/standard/carousel-2.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
      }

      &:nth-child(3) {
        background: url('~@/assets/img/standard/carousel-3.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
      }

      &:nth-child(4) {
        background: url('~@/assets/img/standard/carousel-4.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
      }

      &:nth-child(5) {
        background: url('~@/assets/img/standard/carousel-5.png') no-repeat top 37px right 18px/97px 91px, #ffffff;
      }

      &:hover {
        box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
      }

      h3 {
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
        color: #323335;
        margin-bottom: 16px;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #525760;
      }
    }
    .principle-item:hover{


      background: url('~@/assets/img/standard/carousel-1.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);

      &:nth-child(2) {
        background: url('~@/assets/img/standard/carousel-2.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
      }

      &:nth-child(3) {
        background: url('~@/assets/img/standard/carousel-3.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
      }

      &:nth-child(4) {
        background: url('~@/assets/img/standard/carousel-4.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
      }

      &:nth-child(5) {
        background: url('~@/assets/img/standard/carousel-5.png') no-repeat top 37px right 18px/97px 91px, linear-gradient(180deg, #F3F5F8 0%, #FFF 100%);
      }


    }
  }

  .weight-text {
    color: var(--Text-neutral-11, #323335);
    
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
}
</style>